import * as React from 'react';
import EventCard from '../components/Events/eventCard';
import Seo from '../components/Seo/seo';
import { Row, Col, Container } from 'react-bootstrap';
import styled from 'styled-components';
//import CustomContext from '../../../custom-context';
import { useContext } from 'react';
import algoliasearch from 'algoliasearch/lite';
import Banner from '../components/VisualComponents/topBannerPanel';
import { graphql, useStaticQuery } from 'gatsby';

const EventListStyled = styled.div`
	.bannerContent {
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: start;
		height: 100%;
		margin-left: 3em;
	}

	.description {
		font-weight: 300;
		/*font-size: 1.5em;*/
		font-size: var(--font-size-md);
		margin-bottom: 1em;
		line-height: 1.5em;
	}

	h2 {
		color: var(--primary);
		/*font-size: 2.5rem;*/
		font-size: var(--font-size-xl);
	}

	.connect {
		text-align: right;
		margin-top: 1rem;
		margin-bottom: 1rem;
	}

	.banner {
		width: 25em;
	}

	.bg {
		width: 9em;
	}

	.bannerCol {
		padding: 0;
	}

	@media (max-width: 768px) {
		.bannerContent {
			padding: 1em;
			margin: 0;
			align-items: center;
			text-align: center;
		}

		.description {
			margin-bottom: 0em;
		}
		h2 {
			font-size: var(--font-size-xl);
		}

		.bg {
			display: none;
		}

		.connect {
			text-align: left;
			margin-top: 1rem;
			margin-bottom: 1rem;
		}
		.banner {
			width: 18em;
		}
	}
`;
const EventList = () => {
	const EventListBanner = useStaticQuery(graphql`
		query EventListQuery {
			strapiBanner {
				events_banner {
					id
					strapi_id
					only_image
					image {
						localFile {
							childImageSharp {
								gatsbyImageData
							}
						}
					}
					content {
						title
						caption
						button {
							name
							link
						}
						design_options {
							background_colour
							font_colour
							text_align
							background_image {
								url
								localFile {
									childImageSharp {
										gatsbyImageData
									}
								}
							}
						}
						image_side
					}
				}
			}
		}
	`);

	// segment event tracking and page call
	React.useEffect(() => {
		window.analytics.page('Listing', 'Events', {
			collection_type: 'Event',
			path: window.location.pathname,
			report_type: 'New',
			strapi_id: null,
			title: null,
			url: window.location.href,
		});
	}, []);

	// markup
	//export default function ResourceList(props) {
	//const { user } = useContext(CustomContext);
	//const { data, errors } = props;
	// const user = null;
	var banner = EventListBanner && EventListBanner?.strapiBanner?.events_banner;
	banner.content.title =
		EventListBanner?.strapiBanner?.events_banner.content.title;
	banner.content.caption =
		EventListBanner?.strapiBanner?.events_banner.content.caption;

	const searchClient = React.useMemo(
		() =>
			algoliasearch(
				process.env.GATSBY_ALGOLIA_APP_ID,
				process.env.GATSBY_ALGOLIA_PUBLIC_SEARCH_KEY
			),
		[]
	);
	return (
		<EventListStyled>
			<div>
				<Banner content={banner} title='Events'></Banner>
			</div>

			<main>
				<EventCard
					// userPeopleRoles={userPeopleRoles}
					searchClient={searchClient}
				></EventCard>
			</main>
			{/*  Display SEO details  */}

			<Seo
				title={`Events on ${process.env.GATSBY_WEBSITE_NAME} `}
				description={`Register for upcoming events on ${process.env.GATSBY_WEBSITE_NAME} `}
				keywords='events'
				// image={strapiPage.seo?.shareImage.url}
				slug='/events'
			></Seo>
		</EventListStyled>
	);
};
export default EventList;
